<template>
    <div>
        Transmittal's
    </div>
</template>

<script>
    export default {
        name: "Transmittals"
    }
</script>

<style scoped>

</style>